module.exports = __webpack_public_path__ + "static/media/Tombeau-cover-video.5e7bbdaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-cover-video.jpg
// module id = 603
// module chunks = 0